/** The Galerie: portfolio tiles with a keyboard-navigable lightbox.
 *  Deliberately separate from the shop - these are showcase pieces, not stock. */

import { useState } from 'react'
import Lightbox from '../components/Lightbox'
import { BlurbCard } from '../components/ui'
import { type GalleryItem } from '../lib/api'
import { useApi, useDocumentMeta, useHreflang, useLocale } from '../lib/hooks'
import { pagePaths, t } from '../lib/i18n'

export default function Galerie() {
  const locale = useLocale()
  const strings = t(locale)
  const { data: items } = useApi<GalleryItem[]>(`/api/gallery?locale=${locale}`)
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  useDocumentMeta(strings.meta.galerie.title, strings.meta.galerie.description)
  useHreflang(pagePaths('galerie'))

  return (
    <>
      <section className="bg-paper px-6 pb-12 pt-16 md:px-10 md:pt-24">
        <div className="mx-auto max-w-[1200px]">
          <h1 className="m-0 font-serif text-[clamp(40px,6vw,64px)] font-medium leading-[1.05] text-ink">
            {strings.nav.galerie}
          </h1>
        </div>
      </section>

      <section className="bg-paper px-6 pb-16 md:px-10 md:pb-24">
        <div className="mx-auto max-w-[1200px]">
          <div className="grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
            {(items ?? []).map((item, index) => (
              <BlurbCard
                key={item.id}
                filename={item.filename}
                alt={item.alt}
                title={item.title}
                description={item.subtitle}
                eager={index < 3}
                onClick={() => setOpenIndex(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {openIndex !== null && items ? (
        <Lightbox
          items={items}
          index={openIndex}
          onClose={() => setOpenIndex(null)}
          onNavigate={setOpenIndex}
        />
      ) : null}
    </>
  )
}
